// assets
import { DatabaseOutlined, ApiOutlined, BoxPlotOutlined, AntCloudOutlined, BellOutlined } from '@ant-design/icons';

// icons
const icons = {
  DatabaseOutlined,
  ApiOutlined,
  BoxPlotOutlined,
  AntCloudOutlined,
  BellOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const record = {
  id: 'group-record',
  title: '데이터 조회',
  type: 'group',
  admin: false,
  children: [
    {
      id: 'record-inverter',
      title: '인버터',
      type: 'item',
      url: '/record/inverter',
      icon: icons.DatabaseOutlined,
      breadcrumbs: false
    },

    {
      id: 'record-grid',
      title: '수배전반',
      type: 'item',
      url: '/record/grid',
      icon: icons.ApiOutlined,
      breadcrumbs: false
    },

    {
      id: 'record-joinbox',
      title: '접속반',
      type: 'item',
      url: '/record/joinbox',
      icon: icons.BoxPlotOutlined,
      breadcrumbs: false
    },

    {
      id: 'record-weather',
      title: '기상데이터',
      type: 'item',
      url: '/record/weather',
      icon: icons.AntCloudOutlined,
      breadcrumbs: false
    },

    {
      id: 'record-alert',
      title: '경보및알람',
      type: 'item',
      url: '/record/alert',
      icon: icons.BellOutlined,
      breadcrumbs: false
    }
  ]
};

export default record;
